import { routerApp, baseUrl, enableOnPremise } from '../app.module';
import angular from 'angular';
import { httpRequestGenerator } from './utilities';

routerApp.factory('ManagementClientsService', ['$http', '$log', function($http: angular.IHttpService, $log: angular.ILogService) {
    var requestFunc = httpRequestGenerator(enableOnPremise, $http);
    return {
        getClients: () => {
            return requestFunc({
                url: `${baseUrl}v1/management/client/`,
                method: 'GET'
            });
        },
        getClient: (clientId: string) => {
            return requestFunc({
                url: `${baseUrl}v1/management/client/${clientId}`,
                method: 'GET'
            });
        },
        createClient: (client: any) => {
            return requestFunc({
                url: `${baseUrl}v1/management/client/`,
                method: 'POST',
                data: client
            });
        },
        updateClient: (clientId: string, client: any) => {
            return requestFunc({
                url: `${baseUrl}v1/management/client/${clientId}`,
                method: 'PUT',
                data: client
            });
        },
        disableClient: (clientId: string) => {
            return requestFunc({
                url: `${baseUrl}v1/management/client/${clientId}`,
                method: 'DELETE'
            });
        }
    }
}]);